<template>
  <div>
    <!-- <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/tokenPackage/tokenPackageAdd')"
    >
      新增
    </a-button>
    <a-button
      type="danger"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/lightningDeals/add')"
    >
      新增指删除
    </a-button> -->
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="name" slot-scope="name">
        {{ name.first }} {{ name.last }}
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate">
        <a
          href=""
          v-on:click.prevent="
            topage('/home/eventManagement/registrationDetailsHome')
          "
          >报名详情</a
        >
        <a
          href=""
          v-on:click.prevent="topage('/home/memberManagement/userPullsNew')"
          >用户拉新</a
        >
        <a v-on:click.prevent="showModal">绑定上级</a>
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import { signManageList } from "@/api/storeApi.js";

const columns = [
  {
    title: "用户uid",
    dataIndex: "objId",
    sorter: true,
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "昵称",
    dataIndex: "nickName",
  },
  {
    title: "手机号码",
    dataIndex: "phone",
  },
  {
    title: "报名时间",
    dataIndex: "createTime",
    sorter: true,
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      activityId: "",
    };
  },
  mounted() {
    this.getDetailsManageList();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      signManageList({
        activityId: this.activityId,
        limit: 10,
        page: this.pagination.current,
      }).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    getDetailsManageList() {
      this.activityId = this.$route.query.objId;
      signManageList({ activityId: this.activityId, limit: 10, page: 1 }).then(
        (res) => {
          this.pagination.total = res.count;
          this.data = res.data;
        }
      );
    },
    query() {
      this.loading = true;
      signManageList(this.formInline).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/marketingManagement/eventManagement/registrationDetails/registrationDetailsContent.vue